import { z } from 'zod/v4'
import { useMesaParameterStore } from '@/src/services/Statsig/useMesaParameterStore'

export const CardDesignVariantSchema = z.object({
  header_text: z.string(),
  image_url: z.url(),
})
export const CardImagesSchema = z.record(z.string(), CardDesignVariantSchema)

export const MesaCardDesignSchema = z.object({
  card_details: CardImagesSchema,
})

export type CardDesign = z.infer<typeof MesaCardDesignSchema>

export function useCardDesignParameterStore() {
  return useMesaParameterStore('mesa_card_design')
}
